import { render, staticRenderFns } from "./NameAndAbout.vue?vue&type=template&id=066a67ce&"
import script from "./NameAndAbout.vue?vue&type=script&lang=js&"
export * from "./NameAndAbout.vue?vue&type=script&lang=js&"
import style0 from "./NameAndAbout.vue?vue&type=style&index=0&id=066a67ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
